// @flow
import React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import _ from "lodash";

import colors from '../../assets/css/colors';
import { above, below } from '../../assets/css/media';

import MenuIcon from '../Icons/Menu';
import { TextModal } from '../';

import LeagueSwitcher from './LeagueSwitcher';

const MenuBarContainer = styled.div`
	display: flex;
	justify-content: space-between;
	background: ${colors.nrlDarkGreen};
	height: 55px;
`;

const LeftSide = styled.div`
	display: flex;
	overflow-x: auto;

	${below.phone`
		flex: 2 4 auto;
	`}
`;

const RightSide = styled.div`
	display: flex;
	justify-content: flex-end;

	${below.phone`
		flex: 1 2 50%;
		max-width: 50%;
	`}
`;

const HamburgerButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;

	background: transparent;
	border-radius: 0;
	border: 0 none;
	margin: 0;

	color: ${colors.nrlGreen};
	height: 100%;
	width: 55px;

	font-size: 16px;

	${below.desktop`
		display: none;
	`}
`;

const nav_item_padding_top_bottom = '3px';

const NavItem = styled(NavLink)`
	display: flex;
	align-items: center;
	justify-content: center;

	font-size: 14px;
	line-height: 1;
	font-weight: bold;
	color: ${colors.nrlGreen};
	text-decoration: none;
	white-space: nowrap;

	padding: ${nav_item_padding_top_bottom} 12px;

	&.active {
		padding-bottom: 0;
		border-bottom: ${nav_item_padding_top_bottom} solid ${colors.nrlGreen};
	}

	${above.tablet`
		padding: ${nav_item_padding_top_bottom} 20px;
	`}
`;

type Props = {
	nav_items: Array<Object>,
	openHamburgerMenu: Function,
	leagues: Array<Object>,
	selected_league: ?Object,
	user_id: number,
	is_last_round_started?: boolean
}

type State = {
	show_modal: boolean,
	modal_text: string
}
export class MenuBarBase extends React.PureComponent<Props, State> {
	state = {
		show_modal: false,
		modal_text: ''
	};
	constructor(props: Props, state: State) {
		super(props, state);

		_.bindAll(this, [
			'checkMessage',
			'hideModal',
		]);
	}
	render() {
		const {
			nav_items,
			openHamburgerMenu,
			leagues,
			selected_league,
			user_id,
			is_last_round_started
		} = this.props;

		const { show_modal } = this.state;

		return (
			<React.Fragment>
				<MenuBarContainer>
					<LeftSide>
						<HamburgerButton onClick={openHamburgerMenu}>
							<MenuIcon />
						</HamburgerButton>
						{nav_items && nav_items.map(item => (
							<NavItem
								key={item.name + item.to}
								to={item.to}
								exact={item.exact}
								data-message={is_last_round_started ? item.message : ''}
								onClick={this.checkMessage}
							>
								{item.name}
							</NavItem>
						))}
					</LeftSide>
					<RightSide>
						<LeagueSwitcher
							leagues={leagues}
							selected_league={selected_league}
							user_id={user_id}
						/>
					</RightSide>
				</MenuBarContainer>
				{show_modal && (
					<TextModal
						header_text={'Error'}
						text={this.state.modal_text}
						onClick={this.hideModal}
					/>
				)}
			</React.Fragment>
		);
	}

	checkMessage(event: Object) {
		const { message } = event.currentTarget.dataset;

		if (message && message !== '') {
			event.preventDefault();
			this.setState({
				show_modal: true,
				modal_text: message
			});
		}
		else {
			this.setState({
				show_modal: false,
				modal_text: ''
			});
		}
	}
	hideModal() {
		this.setState({
			show_modal: false,
			modal_text: ''
		});
	}
}

export default MenuBarBase;


// WEBPACK FOOTER //
// ./src/components/MenuBar/MenuBarBase.js